// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__1xxtg","contactContainer":"Footer_contactContainer__TlwSb","text":"Footer_text__3GQv2","button":"Footer_button__3eMA1"};